module.exports = __webpack_public_path__ + "img/dnsPanel.af7f507 1.e474384.svg";